import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";

const SearchVisits = () => {
    const searchFilters = {
        filters: [
            {
                name: "amka",
                label: "ΑΜΚΑ Ασθενή",
                type: "input",
            },
            {
                name: "inQuota",
                label: "Όριο Επισκέψεων",
                type: "dropdown",
                options: [
                    {value: "both", label: "Προβολή όλων"},
                    {value: "true", label: "Συμπεριλαμβάνονται στο όριο"},
                    {value: "false", label: "Δεν συμπεριλαμβάνονται στο όριο"},
                ]
            }
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Αρ. επίσκεψης",
            field: "visitId",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "ΑΜΚΑ Ασθενή",
            field: "identifier",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ονοματεπώνυμο",
            field: "name",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ασφαλιστικός Φορέας",
            field: "socialInsurance",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Τηλέφωνα",
            field: "phones",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ημ/νια έναρξης",
            field: "dateFrom",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ημ/νια λήξης",
            field: "dateTo",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κατάσταση Επίσκεψης",
            field: "status",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Χρεωμένη στο Όριο Επισκέψεων",
            field: "billed",
            editable: false,
            inputType: {
                type: "text",
            }
        }
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search Visits"}
                key={"Prescription Search Visits"}
                hideYearFilter={false}
                allowOtherYears={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}

                allowSorting={false}
                allowPrintResults={true}
                dataEndpoint={"/prescription/export-visits"}
                exportFileName={"Επισκέψεις"}
            />
        </div>
    )
}

export default SearchVisits
